import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

import { designSystem } from '@/styles/styles';

const SvgComponent = props => (
    <Svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} fill="none" {...props}>
        <Path stroke={designSystem.colors.neutral300} strokeWidth={2} d="M1 1h16v16H1V1Z" />
    </Svg>
);
export default SvgComponent;
